import { DocumentTypesPage, SettingsPage, StockLocationsPage, StockControlPage, StockDocumentEditPage } from "./pages"

export const InventoryDocumentTypesPage = DocumentTypesPage
export const InventorySettingsPage = SettingsPage
export const InventoryStockLocationsPage = StockLocationsPage
export const InventoryStockControlPage = StockControlPage
export const InventoryStockDocumentEditPage = StockDocumentEditPage


// WEBPACK FOOTER //
// ./src/inventory/index.ts